module.exports = __webpack_public_path__ + "static/media/security-24px.cb2dce1e.svg";